<template>
  <div class="header">
    <div class="wrapper" v-if="state == 'Home'" >
        <div class="left d-flex">
            <div class="brand" @click="$router.push('/')">
                <img v-if="localeCode == 1033" src="../../../assets/new/logo/New-Logo-ShopDD-EN-1.svg"/>
                <img v-else src="../../../assets/new/logo/New-Logo-ShopDD-TH-1.svg"/>
                <!-- <img src="@/assets/logo/logo-shopdd.svg" /> -->
            </div>
        </div>
        <div class="search d-flex">
            <SearchTopBar
                v-model="search"
                :inputLbl="lbl.topbar.search.placeholder"
                :topSearchTxt="lbl.topbar.search.topSearch"
                inputId="search"
            ></SearchTopBar>
        </div>
        <div class="right d-flex">
            <ShoppingCart @gotoCart="gotoCart($event)"></ShoppingCart>
            <div class="ml-4">
                <ButtonDropdown></ButtonDropdown>
            </div>
        </div>
    </div>
    <modal-master :controller="modalController"></modal-master>
  </div>
</template>

<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin';
import ErrorApiMixin from '@/mixin/ErrorApiMixin';
import AccountMixin from '@/mixin/AccountMixin';
//core
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
// components
import SearchTopBar from '../component/SearchTopBar/SearchTopBar.vue';
import ShoppingCart from '../component/ShoppingCart/ShoppingCart.vue';
import ButtonDropdown from '../component/ButtonDropdown/ButtonDropdown.vue';
// helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    mixins: [LocaleMixin,ModalMixin,ErrorApiMixin,AccountMixin],
    components:{
        SearchTopBar,
        ShoppingCart,
        ButtonDropdown
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            state: "Home",
            search: "",
            blobConfig: Account.getCacheBlob(),
            query: Account.getCacheQuery(),
        }
    },
    created: function () {
        this.cartConfig = Account.getCacheCart();
        console.log(this.localeCode)
    },
    methods: {
        shoppingCartUrl: function(path) {
            if (this.cartConfig.shoppingcart_url) {
                let mainUrl = this.cartConfig.shoppingcart_url
                if(path){
                    mainUrl = this.cartConfig.shoppingcart_url + path
                }
                let token = Account.getToken();
                let localeCode = Locale.getLocaleCode();
                let returnUrl = this.query.returnUrl;
                let appId = ConfigManager.getAppId()
                let api = this.cartConfig.api_prefix
                let brand = 'b2bmarketplace'
                let strUrl = mainUrl
                    + '?return_url=' + returnUrl
                    + '&token=' + token
                    + '&locale=' + localeCode
                    + '&theme=ecommerce_brand_a'
                    + '&multilang=true'
                    + '&appid=' + appId
                    + '&api=' + api
                    + '&brand=' + brand;

                return strUrl
            }
        },
        gotoCart: function(path) {
            if (this.isLogin) {
                const cartUrl = new URL(this.shoppingCartUrl(path));
                if (this.blobConfig.shopping_cart_redirect_b2b_marketplace) {
                    cartUrl.searchParams.set('return_url', encodeURIComponent(window.location.href));
                    cartUrl.searchParams.set('success_url', encodeURIComponent(window.location.origin));
                }
                window.location.replace(cartUrl.toString());
            } else {
                this.goLogin();
            }
        },
        goShoppingCartProduct: async function(path) {
            this.loadingModal.show()
            let token = Account.getToken();
            let accessKey = await this.getShoppingCartAccessKey(token)
            this.loadingModal.hide()

            if (accessKey == null) {
                return
            }

            let appMain = this.blobConfig.appMain;
            let appName = this.blobConfig.appName;
            let url = ConfigManager.getShoppingCartUrl() + `/landing/${appMain}?access_key=${accessKey}&appname_config=${appName}`
            if (path) {
                url = ConfigManager.getShoppingCartUrl() + `/landing/${appMain}/myorder?access_key=${accessKey}&appname_config=${appName}`
            }
            window.location.href = url
        },

        getShoppingCartAccessKey: function(token) {
            return new Promise((resolve) => {
                let currentUrl = window.location.href
                let payload = {
                    returnUrl: currentUrl,
                    successUrl: currentUrl,
                    errorUrl: currentUrl,
                    appId: this.query.appId,
                    appName: this.blobConfig.appName,
                    routeMode: 'push',
                }
                let jsonPayload = JSON.stringify(payload)
                BzbsAuth.apiCreateAccessKey(token, jsonPayload).subscribe({
                    next: (data) => {
                        resolve(data.accessKey)
                    },
                    error: (err) => {
                        resolve(null)
                        this.errorApi(err)
                    },
                })
            })
        },
        goLogin: function() {
            this.confirmModal
                .clearModal()
                .setTitle(this.lbl.alert_popup.login.title)
                .setMsg(this.lbl.alert_popup.login.msg)
                .setBtnOk(this.lbl.alert_popup.login.btnOk)
                .setBtnCancel(this.lbl.alert_popup.login.btnCancel)
                .show();
            this.confirmModal.onClickOk(() => {
                this.$router.push('/login')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "./Header.scss";
</style>
